import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/work-orders/$id/worksheets/$worksheetId')({
	component: () => <Outlet />,
});
